import styled from 'styled-components';
import { gray20, gray90, screenXsMax, screenSmMin, spacer16, spacer24 } from '@spotify-internal/encore-foundation';
var spacer16Raw = parseInt(spacer16, 10);
var spacer24Raw = parseInt(spacer24, 10);

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.dialogFullScreen === 'dark';
};

export default styled.header.withConfig({
  displayName: "Header",
  componentId: "c0qqoq-0"
})(["border-bottom:1px solid ", ";position:relative;@media (max-width:", "){padding:14px ", "px 14px ", ";}@media (min-width:", "){padding:20px ", "px 20px;text-align:center;}"], function (props) {
  return isDarkTheme(props) ? gray20 : gray90;
}, screenXsMax, spacer24Raw + spacer16Raw * 2, spacer24, screenSmMin, spacer24Raw * 3);